import React from 'react';
import { List, Filter, Edit, Create, Datagrid, SimpleForm, required,
		TextField,
		TextInput,DateField, BooleanField, BooleanInput,
		EditButton, DeleteButton  } from 'admin-on-rest';
import { DateInput } from 'admin-on-rest';
import { CardActions } from 'material-ui/Card';
import { RefreshButton } from 'admin-on-rest';

import CHBoolField from '../utils/CHBoolField'
import BulkBlacklistIpsButton from './BulkBlacklistIpsButton';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const IpblacklistActions = () => (
    <CardActions style={cardActionStyle}>
        <RefreshButton />
        <BulkBlacklistIpsButton />
    </CardActions>
);

export const IpblacklistList = (props) => (
    <List title="IP blacklist" perPage={250} actions={<IpblacklistActions />} {...props}>
        <Datagrid >
					
			<TextField source="ipaddress" sortable={false} />
            <TextField source="label" sortable={false} />
            <DateField source="expireson" sortable={false} />
            <CHBoolField source="startswith" sortable={false} />
			<DeleteButton />
			
		</Datagrid>
    </List>
);

export const IpblacklistEdit = (props) => (
    <Edit title="Edit" {...props}>
        <SimpleForm>
           	<TextInput source="ipaddress" />
           	<TextInput source="label" />
           	<BooleanInput source="startswith" />
			<DateInput source="removeclicks_from" />
			<DateInput source="expireson" />
        </SimpleForm>
    </Edit>
);

export const IpblacklistCreate = (props) => (
    <Create title="Create" {...props}>
        <SimpleForm>
           	<TextInput source="ipaddress" />
           	<TextInput source="label" />
			<BooleanInput source="startswith" />
			<DateInput source="removeclicks_from" />
			<DateInput source="expireson" />
        </SimpleForm>
    </Create>
);


// WEBPACK FOOTER //
// ./src/siteclicks/Ipblacklist.js